import { ReactNode } from 'react';
import * as S from './style'
/**
 * Icons
*/
import { X } from '@phosphor-icons/react';

interface IDetails {
    title: string;
    subTitle: string;
    setModalClose: () => void;
    children: ReactNode;
}

export default function LayoutDetails({ title, subTitle, setModalClose, children }: IDetails) {
    return (
        <S.Container>
            <S.Content>
                <S.Header>
                    <S.Infor>
                        <S.Title>
                            {title}
                        </S.Title>
                        <S.SubTitle>
                            {subTitle}
                        </S.SubTitle>
                    </S.Infor>
                    <S.ButtonClose onClick={setModalClose}>
                        <X size={24} />
                    </S.ButtonClose>
                </S.Header>
                {children}
            </S.Content>
        </S.Container>
    )
}